import { jsxs as k, Fragment as $, jsx as s } from "react/jsx-runtime";
import { $ as b, d as g, ai as x } from "../../vendor-Dd6qj6gJ.js";
import "../../hooks/useInputSystem/key/constants.js";
import { createKey as _ } from "../../hooks/useInputSystem/key/utils.js";
import "react";
import { getSpacingClasses as u } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index36.css';const j = "_hotkey_aao1z_1", H = "_key_aao1z_11", a = {
  hotkey: j,
  key: H
};
function C({ keys: r, name: i, m: n, mt: c, mr: d, mb: p, ml: l }) {
  const { visuallyHiddenProps: m } = b(), y = g(a.hotkey, u({ m: n, mt: c, mr: d, mb: p, ml: l })), o = r.map((e) => typeof e == "string" ? _(e) : e), f = o.map((e) => e.label).join(" + "), h = `${i} shortcut: Press ${f}`, t = x();
  return /* @__PURE__ */ k($, { children: [
    /* @__PURE__ */ s("kbd", { "aria-describedby": t, className: y, "data-component": "Hotkey", children: o.map((e) => /* @__PURE__ */ s("kbd", { "aria-hidden": !0, className: a.key, children: e.label }, String(e.id))) }),
    /* @__PURE__ */ s("span", { id: t, ...m, children: h })
  ] });
}
export {
  C as Hotkey
};
